import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

class ConfirmationRemoveModal extends Component {
  static propTypes = {
    onClose: PropTypes.func,
    onRemove: PropTypes.func,
    item: PropTypes.object
  };

  render() {
    return (
      <Modal
        show={true}
        backdrop='static'
        container={this}
        dialogClassName='confirmation-remove-file-modal'
        id='confirmation-remove-file'>
        <Modal.Body>
          <p>Delete <span style={{ fontWeight: 600 }}>{this.props.item.name}</span>?</p>
          <div className='confirm-remove-file-group-btn'>
            <button className='btn btn-primary btn-siteone-default' onClick={this.props.onClose}>Cancel</button>
            <button className='btn btn-siteone btn-siteone-danger' onClick={() => this.props.onRemove(this.props.item)}>Delete</button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default ConfirmationRemoveModal;



// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/confirmation-remove-modal.js